import { EnumerationDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
import { List } from 'immutable';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import getIn from 'transmute/getIn';
import { CTA } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
export const getEventSubjectVersionOptions = (filterFamily, condition) => {
  const options = getIn(['field', 'options'], condition) || [];
  const versionOptions = [];
  if (filterFamily === CTA) {
    if (getIn(['field', 'userHasNoAccess'], condition)) {
      return List([PropertyOptionRecord({
        value: condition.value,
        label: I18n.text('newCustomerDataFilters.restrictedAsset.assetLabel.CTA_VERSION')
      })]);
    }
    versionOptions.push(PropertyOptionRecord({
      value: __ANY_CTA,
      label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyCta.input')
    }));
  }
  for (const option of options) {
    versionOptions.push(PropertyOptionRecord({
      value: option.value,
      label: option.text
    }));
  }
  return List(versionOptions);
};
export const makeEventSubjectVersionField = (filterFamily, condition, placeholder) => {
  return DSFieldRecord({
    displayType: EnumerationDisplayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.${filterFamily}.${EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION}`),
    name: EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT_VERSION,
    type: STRING,
    displayOrder: 1,
    options: getEventSubjectVersionOptions(filterFamily, condition),
    placeholder
  });
};